import { HYPHEN } from "constants/search-table";

export const toInteger = (value?: number) => {
  if (!value) {
    return null;
  }
  if (typeof value === "string") {
    return +value;
  }
  return value;
};

export const omitText = (text?: string | null, length = 10) => {
  if (!text) {
    return HYPHEN;
  }
  return text.length > length ? `${text.slice(0, length)}...` : text;
};

export const formatToManYen = (value?: string | number | null): string => {
  if (value == null) {
    return HYPHEN;
  }
  // 数値に変換できるかチェック
  const numValue = typeof value === "string" ? parseFloat(value) : value;

  // NaN（数値に変換できない）かどうかをチェック
  if (Number.isNaN(numValue)) {
    return HYPHEN;
  }

  // 万円単位に変換して小数第1位まで表示
  return `${(numValue / 10000).toFixed(1)}万円`;
};

export const getValidString = (
  value: string | null | undefined,
): string | null => {
  if (value === null || value === undefined || value === "null") {
    return null;
  }
  return value;
};

export const getValidStringArray = (valueArray: string[] | null): string[] => {
  return valueArray
    ? valueArray.filter(value => getValidString(value) !== null)
    : [];
};

export const convertEnToJa = (
  enVal: string | null | undefined,
  map: Record<string, string>,
): string | null => {
  const validEnVal = getValidString(enVal);

  // 英語名称が引数で受け取ったmapに存在する場合、日本語名称への変換を行う
  if (validEnVal != null && map[validEnVal]) {
    return map[validEnVal];
  }
  return null;
};
